var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgImgSearch(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 26,
    viewBox: "0 0 32 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_353_57)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 9.1C12.4 9.1 10.3 11 10.3 13.4C10.3 15.8 12.4 17.7 15 17.7C17.6 17.7 19.7 15.8 19.7 13.4C19.7 11 17.6 9.1 15 9.1ZM8 13.5C8 9.9 11.1 7 15 7C18.9 7 22 9.9 22 13.5C22 17.1 18.9 20 15 20C11.1 20 8 17 8 13.5Z",
    fill: "#2F2F2F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 3.7999C3 3.2999 3.5 2.8999 4.1 2.8999H5.8C6.4 2.8999 6.9 3.2999 6.9 3.7999V4.9999C6.9 5.4999 6.4 5.8999 5.8 5.8999C5.5 5.9999 5.2 5.7999 5 5.6999C4.8 5.7999 4.5 5.9999 4.1 5.9999C3.5 5.9999 3 5.5999 3 5.0999V3.7999Z",
    fill: "#2F2F2F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.6 22.3C18.6 22 18.4 21.8 18.1 21.8H3.2C2.9 21.8 2.6 21.7 2.4 21.5C2.2 21.3 2.1 21 2.1 20.7V7.6C2.1 7.3 2.2 7 2.4 6.8C2.6 6.6 2.9 6.5 3.2 6.5H7.2C8.2 6.5 9 5.9 9.5 5.3L9.6 5.2L11.3 2.4C11.5 2.2 11.7 2.1 11.9 2.1H18.1C18.3 2.1 18.5 2.2 18.7 2.4L20.4 5.2L20.5 5.3C21 5.9 21.8 6.5 22.8 6.5H26.8C27.1 6.5 27.4 6.6 27.6 6.8C27.8 7 27.9 7.3 27.9 7.6V15.4C27.9 15.7 28.1 15.9 28.4 15.9H29.6C29.9 15.9 30.1 15.7 30.1 15.4V7.6C30.1 6.7 29.8 5.9 29.2 5.3C28.6 4.7 27.8 4.3 26.9 4.3H22.9C22.7 4.3 22.5 4.2 22.3 4L20.6 1.2L20.5 1.1C20 0.4 19.2 0 18.2 0H12C11.1 0 10.3 0.5 9.7 1.1L9.6 1.2L7.8 4C7.5 4.2 7.3 4.3 7.2 4.3H3.2C2.3 4.3 1.5 4.6 0.9 5.3C0.3 5.9 0 6.7 0 7.6V20.7C0 21.6 0.3 22.4 0.9 23C1.5 23.6 2.3 24 3.2 24H18.1C18.4 24 18.6 23.8 18.6 23.5V22.3Z",
    fill: "#2F2F2F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.5004 25.8999L25.0004 24.2999H22.9004L22.4004 25.8999H20.4004L22.9004 17.8999H25.5004L28.0004 25.8999H25.5004ZM23.3004 22.4999H24.6004L24.0004 20.1999L23.3004 22.4999Z",
    fill: "url(#paint0_linear_353_57)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.2002 17.8999V25.8999H28.7002V17.8999H31.2002Z",
    fill: "url(#paint1_linear_353_57)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_353_57",
    x1: 24.2004,
    y1: 17.8999,
    x2: 24.2004,
    y2: 25.8999,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#008AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#005399"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_353_57",
    x1: 29.9502,
    y1: 17.8999,
    x2: 29.9502,
    y2: 25.8999,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#008AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#005399"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_353_57"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 26,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgSearch);
export default __webpack_public_path__ + "static/media/img_search.67f2de05ccffd97da0751cc36889e6e1.svg";
export { ForwardRef as ReactComponent };